/*
 * WELLF product page interactions - gallery, FAQ accordion, sticky FAB, lazy video.
 * Commerce (subscribe toggle + Ajax add) is handled by the shared wellf-buy-card.js;
 * this file is the product-only behaviour layered on top.
 */
(function () {
  'use strict';

  /* ── Gallery: thumbs + arrows + scroll-sync ── */
  (function gallery() {
    var track = document.getElementById('pdpTrack');
    if (!track) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
    var slides = track.children;

    function setActive(i) {
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(Number(t.getAttribute('data-gallery-thumb')) === i));
      });
    }
    function go(i) {
      var n = slides.length;
      if (n === 0) return;
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    }
    function current() {
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(Number(t.getAttribute('data-gallery-thumb'))); });
    });
    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; setActive(current()); });
    }, { passive: true });
  })();

  /* ── FAQ accordion (single-open) ── */
  (function faq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.faq__item'));
    if (!items.length) return;
    function setOpen(target, open) {
      items.forEach(function (other) {
        var isOpen = other === target && open;
        other.setAttribute('data-open', String(isOpen));
        var q = other.querySelector('[data-faq-q]');
        var icon = other.querySelector('.faq__q-icon');
        if (q) q.setAttribute('aria-expanded', String(isOpen));
        if (icon) icon.textContent = isOpen ? '−' : '+';
      });
    }
    items.forEach(function (item) {
      var btn = item.querySelector('[data-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        setOpen(item, item.getAttribute('data-open') !== 'true');
      });
    });
    // Open + reveal a specific answer when arrived via a #faq-N deep link
    // (search results / LLM citations link straight to one answer).
    function openFromHash() {
      var id = (location.hash || '').replace('#', '');
      if (!id) return;
      var target = document.getElementById(id);
      if (target && target.classList.contains('faq__item')) {
        setOpen(target, true);
        target.scrollIntoView({ block: 'center' });
      }
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  })();

  /* ── Product-details accordion (Ingredients / Nutrition / Third-party): each toggles independently ── */
  (function accordion() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.acc__item'));
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('[data-acc-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') !== 'true';
        item.setAttribute('data-open', String(open));
        btn.setAttribute('aria-expanded', String(open));
        var icon = item.querySelector('.acc__icon');
        if (icon) icon.textContent = open ? '−' : '+';
      });
    });
  })();

  /* ── Sticky FAB: show when the in-card add button scrolls away; mirror its action + price ── */
  (function fab() {
    var fab = document.querySelector('[data-product-fab]');
    var addBtn = document.querySelector('[data-buy-add]');
    if (!fab || !addBtn) return;
    var form = addBtn.closest('form');
    var fabBtn = fab.querySelector('[data-fab-add]');
    var fabPrice = fab.querySelector('[data-fab-price]');
    var amountEl = document.querySelector('[data-buy-amount]');

    if (fabBtn && form) {
      fabBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    function syncPrice() {
      if (fabPrice && amountEl) fabPrice.textContent = amountEl.textContent.trim();
    }
    document.querySelectorAll('[data-buy-mode]').forEach(function (b) {
      b.addEventListener('click', function () { requestAnimationFrame(syncPrice); });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        fab.setAttribute('data-show', String(past));
      }, { threshold: 0, rootMargin: '-72px 0px 0px 0px' });
      io.observe(addBtn);
    }
  })();

  /* ── Lazy rotating video: load the playable format, play only on screen ── */
  (function video() {
    var v = document.getElementById('formulaVideo');
    if (!v) return;
    v.loop = true; v.muted = true; v.defaultMuted = true; v.playsInline = true;
    if (!v.src) {
      var canHevc = v.canPlayType && v.canPlayType('video/mp4; codecs="hvc1"');
      var src = canHevc ? v.getAttribute('data-mp4') : v.getAttribute('data-webm');
      if (src) v.src = src;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.25 });
      io.observe(v);
    }
  })();
})();
